<style lang='scss'>
	#ruleform_bor {
		textarea {
			border: none !important;
			outline: none !important;
			box-shadow: 0 0 0 transparent;
			padding: 0;
		}
	}

	#main-handhomes {
		.lable_green {
			color: #0c8b97;
			font-size: .8rem;
		}

		.green_icon {
			color: #3bc7a1;
			font-size: 1rem;
		}

		.ant-modal-header,
		.ant-modal-body {
			border-radius: 0 !important;
		}

		.ant-modal-header,
		.ant-modal-body {
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}

		.main-hand-title {
			position: absolute;
			top: 0;
			left: 0;

			div {
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color: #e5e5e5;
			}
		}

		.wland {
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		.inhover img{
				display: none;
		}
		.inhover:hover img{
				display: inline-block;
		}
		.gland {
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}

		.paginationView {
			padding: 0.5rem 0.5rem;
			display: flex;
			align-items: center;
			width: 100%;
			color: #666666;
			/* height:calc(100vh - 142px); */
		}
	}

	#tubody-quera>div {
		padding: 1px 0;
	}

	#tubody-quera {
		background-color: #fff;

		.main-mybody {
			padding: .5rem 1.5rem 0;
			/* overflow-y: auto;
			min-height: 12rem;
			max-height: 16rem; */
		}

		.ant-empty-normal {
			margin: 7rem 0;
		}

		.main-wid {
			width: 85%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}

		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .2rem 0;
		}

		.btn {
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .8rem;
			color: #fff;
			border: 0;
			/* border-radius: 5px; */
			margin: 0 1rem;
			background-color: #0c8b97;
		}

		.warp_daochu {
			border-top: 1px solid rgb(232, 232, 232);
			display: flex;
			justify-content: space-between;
			padding: 1rem .5rem;

			div {
				font-size: .7rem;
			}
		}

		.warp_mess {
			text-align: right;
			margin-bottom: .3rem;
			padding: .2rem 0 .5rem;
		}
		.pad_textarea{
			padding: 0 1rem 0 1.5rem;
			.ant-row{
				margin-bottom: 0.3rem;
			}
		}
	}
	#btnx {
		cursor: pointer;
		width: 3rem;
		height: 1.7rem;
		font-size: .8rem;
		color: #fff;
		border: 0;
		margin: 0 1rem;
		background-color: #3bc7a1;
		border-radius: 1rem;
	}
</style>
<template>
	<div>
		<a-modal width='60rem' id='main-handhomes' title='title' v-model='visible' @on='handleOk' 
		@cancel='handleCancel'
		:footer="null" :dialog-style="{ top: '15vh' }" :keyboard='false' :maskClosable='false'>
			<div class='main-hand-title'>
				<div style="position: relative;top: .44rem;">添加問題話術</div>
			</div>
			<div style="display: flex;">
				<div v-for='(item,ind) in params.FQAtypeList' :key='ind + "0716"' v-if='!item.ishand' class='inhover'
					:class='island == item.typeid?"wland":"gland"' @click="fanfn(item)" style="position: relative;cursor: pointer;">
					{{item.title}}
					<img :src="island == item.typeid?require('@/image/new/tdelete1.png'):require('@/image/new/tdelete.png')" alt="" style="position: absolute;top: .3rem;right: .3rem;width: .9rem" @click='handdelet(item)'>
				</div>
				<div class='btn_list' style="margin-left: 1rem;display: flex;justify-content: center;align-items: center;" v-if='pad_textareas'>
					<a-input style='width: 6rem;' v-model='tvalue'></a-input>
					<button id='btnx' @click='handend'>完成</button>
					<button id='btnx' style="background-color: #ffa647;" @click="pad_textareas = !pad_textareas;tvalue = ''">取消</button>
				</div>
				<div class='btn_list' style="margin-left: 1rem;line-height: 2.2rem;" @click='pad_textareas = !pad_textareas' v-else>
					<a-icon type="plus" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem' />
					<span style="color:#3bc7a1;font-size: 0.8rem;">添加類別</span>
				</div>
			</div>
			<div id='tubody-quera'>
				<div class='main-mybody' style="padding-top: 1.5rem;">
					<a-form-model ref='ruleForm' id='ruleform_bor' :model="form" labelAlign='left' layout="inline"
						hideRequiredMark>
						<div v-for="(item,index) in params.FQAList" :key="index + '11111'">
							<div>
								<div style="display: flex;justify-content: space-between;">
									<span style="color: #0C8B96;font-size: 0.8rem;">{{'Q'+(index+1)+': '}}</span>
									<a-textarea class='lable_green' placeholder=" " auto-size 
									v-model='item.question' />
									<!-- <div v-else class='lable_green'>{{item.question}}</div> v-if='item.imgShowbol' -->
									<!-- <a-icon type="form" @click="" class='green_icon' @click='item.imgShowbol = !item.imgShowbol'/> -->
									
									<a-icon type="plus" @click="" class='green_icon' style='margin-right: .5rem;'
									 @click='handadd(item,index)'/>
									<img :src="require('@/image/new/tdele1.png')" alt="" style="width: .85rem;height: .85rem;"
									@click='params.FQAList.splice(index,1)'>
										<!-- <img :src="require('@/image/new/tadd1.png')	" alt=""> -->
								</div>
								<div style="display: flex;justify-content: space-around;">
									<span style="color: #000;font-size: 0.8rem;">{{'A'+(index+1)+': '}}</span>
									<a-textarea v-model="item.answer" placeholder=" "
										:auto-size="{ minRows: 1, maxRows: 5 }" />
									<!-- <pre v-else class='fonts'>{{item.answer}}</pre>v-if='item.imgShowbol' -->
								</div>
							</div>
							<div style="width: 100%;height: 1px;border-bottom: 1px solid rgb(232, 232, 232);margin-bottom: .4rem;"></div>
						</div>
					</a-form-model>
				</div>
				<div id='supplylist'>
					<div class="paginationView" >
						<div v-if='false' class='btn_list' style="margin-left: 1rem;" @click='pad_textarea = !pad_textarea'>
							<a-icon type="plus" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem' />
							<span style="color:#3bc7a1;font-size: 0.8rem;">添加問題</span>
						</div>
						<!-- <div>
							<a-button  class="bottomBtn" style="background-color:#ffa647;" @click='visible_bold = 1'>
								<img src="../../image/icon_tianjia.png" class="btnIcon" />
								<span>添加</span>
						</div> -->
						<div style="margin-left:auto;">
							<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
								:pageSize="params.perPage" />
						</div>
						<div class="pageTzView">
							<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
							<span @click="tzEvent">跳轉</span>
						</div>
					</div>
				</div>
				<div class='pad_textarea' v-if='pad_textarea'>
					<a-row>
						<a-col :span='2'>添加問題</a-col>
						<a-col :span='22'>
							<a-textarea v-model="form.question" placeholder=" " :auto-size="{ minRows: 3, maxRows: 5 }" />
						</a-col>
					</a-row>
					<a-row>
						<a-col :span='2'>添加答案</a-col>
						<a-col :span='22'>
							<a-textarea v-model="form.answer" placeholder=" " :auto-size="{ minRows: 3, maxRows: 5 }" />
						</a-col>
					</a-row>
				</div>
				<div style="width: 100%;height: 1px;border-bottom: 1px solid rgb(232, 232, 232);margin-bottom: .4rem;">
				</div>
				<div class='warp_mess'>
					<button class='btn1' @click='resetForm("1")' :disabled='loading'>保存</button>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';

	export default {
		name: 'handhome',
		props: ['itemobj'],
		components: {},
		data() {
			return {
				loading:false,
				tvalue:'',
				pad_textareas:false,
				pad_textarea:false,
				tzPageNum: '',
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					hot_status: '',
					perPage: 10, //每頁條目數
					FQAList:[],
					FQAtypeList:[]
				},
				visible: true,
				island: 1,
				form: {
					answer: "",
					question: "",
					typeid: ''
				},
			}
		},
		mounted() {
			this.getdate();
		},
		watch: {
			itemobj: {
				deep: true,
				immediate: true,
				handler(ev) {}
			},
		},
		methods: {
			handdelet(ev){
				this.$ajax({
					method:'post',
					url:this.$api.dropTalkFAQTypeByTypeid,
					data:{
						typeid:ev.typeid
					}
				}).then(res=>{
					if(res.data.qmiscode == 1000){
						this.island = ''
						this.getdate();
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			handend(){
				this.$ajax({
					method:'post',
					url:this.$api.TalkFAQtype,
					data:{
						title:this.tvalue
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						this.pad_textareas = !this.pad_textareas
						this.tvalue = ''
						this.getdate(this.island);
					}
				})
			},
			handadd(item,ind){
				this.params.FQAList.splice(ind+1,1,{
					FAQid: '',
					answer: "",
					question: "",
					// sort: 2,
					typeid: item.typeid,
				})
			},
			fanfn(v){
				this.island = v.typeid
				this.getdate(this.island);
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.getdate();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.getdate();
			},
			getdate(item=1) {
				this.$ajax({
					method:'post',
					url:this.$api.getTalkFAQ,
					data:{
						// "searchstr":"怎樣",
						 "typeid":item,
						 "pageNum":this.params.pageNum,
						 "perPage":4
					}
				}).then(res=>{
					if(res.data.qmiscode === 1000){
						res.data.FQAList.map(val=>{
							val['imgShowbol'] = true
						})
						if(!this.island){
							this.island =  params.FQAtypeList[0]['typeid']
						} 
						this.params = res.data
					}
				})
			},
			handleOk() {

			},
			resetForm(){
				this.loading = true
				// if(this.pad_textarea){
				// 	if(this.form.answer){
				// 		if(this.form.question){
				// 		this.params.FQAList.push({
				// 			answer: this.form.answer,
				// 			question: this.form.question,
				// 			typeid: this.island	
				// 		})
				// 		}
				// 	}
				// }
				let arr = [];
				this.params.FQAList.map((ev)=>{
					if(ev.answer&&ev.question){
						arr.push(ev)
					}
				})
				
				this.$ajax({
					method:'post',
					url :this.$api.newTalkFAQ,
					data:{
						FQAList:arr,
						typeid: this.island	
					}
				}).then(res=>{
					this.loading = false
					if(res.data.qmiscode === 1000){
						this.form = {
							answer:'',
							question:'',
							typeid:''
						}
						this.getdate(this.island);
					}else{
						this.$message.warning(res.data.qmismsg)
					}
				})
			},
			handleCancel() {
				this.$emit('child', 1)
			},
		}
	}
</script>
